import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

type RecuringAvailabilityConfirmationModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

const RecuringAvailabilityConfirmationModal = ({ onClose, onConfirm }: RecuringAvailabilityConfirmationModalProps) => {
  return (
    <Modal
      aria-label="Update repeating availability"
      open={true}
      onOpenChange={(open) => !open && onClose()}
      body={
        <Box
          data-testid="RecuringAvailabilityConfirmationModal"
          css={{ display: 'flex', flexDirection: 'column', gap: 'default', marginBottom: 'tighter' }}
        >
          <Heading fontFamily="heading-alt" level={4}>
            Update repeating availability
          </Heading>
          <Paragraph>Your changes will be applied to all the other days where this time frame repeats.</Paragraph>
        </Box>
      }
      footer={
        <ButtonGroup aria-label="Modal actions">
          <Modal.Close>
            <TextButton data-testid="RecuringAvailabilityConfirmationModal-CancelBtn">Cancel</TextButton>
          </Modal.Close>
          <Button data-testid="RecuringAvailabilityConfirmationModal-ConfirmBtn" emphasis="filled" onClick={onConfirm}>
            Update
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default RecuringAvailabilityConfirmationModal;
